import LanguageOutputExamples from './languageOutputExamplesField/LanguageOutputExamplesField'
import Region from './Region'
import RuleInstructionField from './RuleInstructionField'

type Props = {
  title: string
  description: string
}

const FormContent = ({ title, description }: Props) => {
  return (
    <>
      <div className="flex flex-col text-base-700 pb-5 border-b border-gold-400">
        <div className="text-2xl font-medium font-relais mb-4 px-6 pt-6">
          {title}
        </div>
        <div className="text-sm px-6">{description}</div>
        <Region />
      </div>
      <div className="flex flex-col p-6 overflow-auto h-full">
        <div>
          <RuleInstructionField />
        </div>
        <div className="flex flex-col text-base-700 my-6 border-b border-gold-400" />
        <LanguageOutputExamples />
      </div>
    </>
  )
}

export default FormContent
